var map = {
	"./blue/up.png": "./src/assets/image/blue/up.png",
	"./purple/up.png": "./src/assets/image/purple/up.png",
	"./red/up.png": "./src/assets/image/red/up.png",
	"./yellow/up.png": "./src/assets/image/yellow/up.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/up\\.png$";